import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TrackingService } from './tracking.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {

  public trackings: any = [];
  constructor(
    private trackingService: TrackingService,
    private config: DynamicDialogConfig,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadTracking();
  }

  loadTracking(){
    this.trackingService.all({
      entity_id: this.config.data.entity_id,
      entity_pk_id: this.config.data.entity_pk_id
    }).subscribe(
      data=>{
        this.trackings = data.rows;
      },
      error=>{
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  getActionDescription(action:string){
    let ret = "";
    if(action=="add") ret = "Se ha creado el registro";
    if(action=="update") ret = "El registro ha sido actualizado";
    if(action=="remove") ret = "El registro ha sido eliminado";
    if(action=="delete") ret = "Registro eliminado físicamente";
    return ret;
  }

}
